/**
 * @file 引导打开浏览器 组件
 */
import {defineComponent} from 'san';
import {GUIDE_URL} from '../../../../common/const/index';
import styles from './index.module.less';

const GuideMarker = defineComponent({
    template: /* html */ `
        <div class="guide-marker-content">
            <img class="${styles['guide-marker']}" src="{{guide}}" alt="引导标识"/>
        </div>
    `,
    initData() {
        return {
            guide: GUIDE_URL,
        };
    },
});

export default GuideMarker;